module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalOpen),
      expression: "modalOpen"
    }],
    staticClass: "modal-wide",
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("profile.kyc.informationsMissing")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(!_vm.user.mangopay_id) ? _c('form', {
    attrs: {
      "id": "lightKycForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateUser()
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t("profile.kyc.addMissingInformations")))]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "mb-20 mt-30"
  }, [_c('strong', [_vm._v("\n                " + _vm._s(((_vm.user.full_name) + " (" + (_vm.user.email) + ")")) + "\n              ")])]), _vm._v(" "), _c('datepicker', {
    staticClass: "mb-20",
    attrs: {
      "format": "yyyy-MM-dd",
      "typeable": false,
      "language": _vm.datapickerLang,
      "input-class": "form-control",
      "placeholder": _vm.$t('profile.edit.birthday')
    },
    model: {
      value: (_vm.user.birthday),
      callback: function($$v) {
        _vm.$set(_vm.user, "birthday", $$v)
      },
      expression: "user.birthday"
    }
  }), _vm._v(" "), (_vm.countries.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.country_id),
      expression: "user.country_id"
    }],
    staticClass: "form-control mb-20",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.$t('country')))]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.countries.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.country_of_residence_id),
      expression: "user.country_of_residence_id"
    }],
    staticClass: "form-control mb-20",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "country_of_residence_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.$t('countryOfResidence')))]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('alert', {
    attrs: {
      "error": _vm.alert.error,
      "success": _vm.alert.success
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.mangopay_id) ? _c('user-kyc', {
    attrs: {
      "documentId": _vm.user.kyc_document_id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px",
      "margin": "5px"
    },
    attrs: {
      "slot": "footer",
      "type": "submit",
      "form": "lightKycForm",
      "disabled": !_vm.isValid
    },
    slot: "footer"
  }, [(!_vm.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t("save")))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.processing,
      "color": '#fff',
      "size": "17px"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409710f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/LightKYC.vue
// module id = 801
// module chunks = 1